/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= append_javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

// import 'bootstrap';


import $ from "expose-loader?exposes=$,jQuery!jquery"
import '@fortawesome/fontawesome-pro/js/all.js';
import ujs from '@rails/ujs';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import { printNoCommentsInit, printWithCommentsInit } from '../utils/util';


ujs.start();

// console.log('Hello World from Shakapacker');


